var transitionNav = {
    selectors: {
        trigger: '[data-transition-nav]',
    },
    init: function () {
        var self = this;

        $(self.selectors.trigger).on('click', function (e) {
            e.preventDefault();

            var $this = $(this),
                classToAdd = $this.attr('data-transition-nav'),
                href = $this.attr('href');

            $(document.body).addClass(classToAdd);

            setTimeout(function () {
                window.location = href /*+ '#scroll-to-content'*/;
            }, 1000);
        });
    },
};

export { transitionNav };
